/**
 * Fælles scroll-lås for body (dialoger, sheets, mobilmenu, indkøbsskuffe, rundtur).
 * Tæller låse, så flere samtidige låse ikke kan efterlade body låst: den oprindelige værdi gendannes først,
 * når den sidste lås frigives. Tidligere gemte hver lås "forrige" værdi selv, og ved overlappende låse
 * (fx mobilmenu + sheet) kunne en forældet 'hidden' blive gendannet, så siden forblev låst.
 */
let locks = 0;
let original = '';

export function lockBodyScroll(body: HTMLElement = document.body): void {
  if (locks === 0) {
    original = body.style.overflow;
    body.style.overflow = 'hidden';
  }
  locks += 1;
}

export function unlockBodyScroll(body: HTMLElement = document.body): void {
  if (locks === 0) return;
  locks -= 1;
  if (locks === 0) body.style.overflow = original;
}

/** Kun til tests. */
export function scrollLockCount(): number {
  return locks;
}
